// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__nnHSK","info":"Panel_info__Q9rpi","note":"Panel_note__BArlO","close":"Panel_close__Z2+iK","btns":"Panel_btns__z0S2l","button":"Panel_button__nPkCv"};